export function isDocOnFocus() {
  if (typeof document.hidden !== "undefined") {
    return !document.hidden;
  } else {
    return document.hasFocus();
  }
}
